import {
  Box,
  CircularProgress,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";

import { useQuotePriceExchangeRates } from "components/ConvertedPriceTooltip";

import { QuotePreview } from "../../../QuotePreview";

interface Props {
  quotes: CondensedQuote[] | null;
  loading: boolean;
  error: string | null;
  currentPage: number;
  pageCount: number;
  onPageSelected: (newPageNumber: number) => void;
}

export function CarrierQuoteList(props: Props) {
  const { quotes, loading, error, currentPage, pageCount, onPageSelected } =
    props;
  // Fetched once for the whole list rather than per quote: every price converts
  // at the same latest rate.
  const { cadPerUsd, usdPerCad } = useQuotePriceExchangeRates();

  if (loading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  if (error != null) {
    return (
      <Stack>
        <Typography color="red" align="center">
          {error}
        </Typography>
      </Stack>
    );
  }
  if (quotes === null) {
    return <div />;
  }
  if (quotes.length === 0) {
    return (
      <Typography
        sx={{ ml: "2rem", mb: "2rem" }}
        variant="body1"
        textAlign="center"
      >
        You do not have any quotes.
      </Typography>
    );
  }

  return (
    <Stack direction="column" justifyContent="center" spacing={1.5}>
      {quotes.map((quote) => (
        <Box key={quote.quote_action}>
          <QuotePreview
            quote={quote}
            cadPerUsd={cadPerUsd}
            usdPerCad={usdPerCad}
          />
        </Box>
      ))}
      <Box my="1rem" display="flex" alignItems="center" justifyContent="center">
        <Pagination
          count={pageCount}
          onChange={(_e: React.ChangeEvent<unknown>, value: number) =>
            onPageSelected(value)
          }
          page={currentPage}
        />
      </Box>
    </Stack>
  );
}
